
let yearType = {
    value: '',
}

export { yearType };